// extracted by mini-css-extract-plugin
export default {"image-preview-container":"style_image-preview-container__9lVch","image-details-container":"style_image-details-container__Zyew0","image-size":"style_image-size__CxgLz"};